import Icon from "./IconBase.js";
const NoGlobalSearch = (props) => {
  return (
    <Icon width="69" height="56" viewBox="0 0 69 59" {...props}>
      <svg
        width="69"
        height="56"
        viewBox="0 0 69 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.03125"
          y="0.424805"
          width="68.9375"
          height="55.15"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57.1115 18.3486C58.1775 18.3486 59.0417 19.2128 59.0417 20.2789C59.0417 21.3449 58.1775 22.2091 57.1115 22.2091H46.0815C47.1475 22.2091 48.0117 23.0733 48.0117 24.1394C48.0117 25.2054 47.1475 26.0696 46.0815 26.0696H52.148C53.214 26.0696 54.0782 26.9338 54.0782 27.9999C54.0782 29.0659 53.214 29.9301 52.148 29.9301H49.3425C47.9984 29.9301 46.9087 30.7943 46.9087 31.8604C46.9087 32.5711 47.4602 33.2145 48.5632 33.7906C49.6293 33.7906 50.4935 34.6548 50.4935 35.7209C50.4935 36.7869 49.6293 37.6511 48.5632 37.6511H25.676C24.6099 37.6511 23.7457 36.7869 23.7457 35.7209C23.7457 34.6548 24.6099 33.7906 25.676 33.7906H14.9217C13.8557 33.7906 12.9915 32.9264 12.9915 31.8604C12.9915 30.7943 13.8557 29.9301 14.9217 29.9301H25.9517C27.0178 29.9301 27.882 29.0659 27.882 27.9999C27.882 26.9338 27.0178 26.0696 25.9517 26.0696H19.058C17.9919 26.0696 17.1277 25.2054 17.1277 24.1394C17.1277 23.0733 17.9919 22.2091 19.058 22.2091H30.088C29.0219 22.2091 28.1577 21.3449 28.1577 20.2789C28.1577 19.2128 29.0219 18.3486 30.088 18.3486H57.1115ZM57.1115 26.0696C58.1775 26.0696 59.0417 26.9338 59.0417 27.9999C59.0417 29.0659 58.1775 29.9301 57.1115 29.9301C56.0454 29.9301 55.1812 29.0659 55.1812 27.9999C55.1812 26.9338 56.0454 26.0696 57.1115 26.0696Z"
          fill="#F3F7FF"
        />
        <path
          d="M33.2591 37.0998C38.3609 37.0998 42.4967 32.9639 42.4967 27.8621C42.4967 22.7603 38.3609 18.6245 33.2591 18.6245C28.1573 18.6245 24.0215 22.7603 24.0215 27.8621C24.0215 32.9639 28.1573 37.0998 33.2591 37.0998Z"
          fill="#F3F7FF"
          stroke="#00B0F5"
          strokeWidth="0.689375"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.7788 35.0299C32.2638 35.1194 32.7572 35.1659 33.259 35.1694C37.2948 35.1694 40.5664 31.8978 40.5664 27.8621C40.5664 23.8263 37.2948 20.5547 33.259 20.5547C32.2223 20.5547 31.236 20.7706 30.3427 21.1599C28.7902 21.8363 27.5184 23.0364 26.7502 24.537C26.2397 25.5344 25.9517 26.6646 25.9517 27.8621C25.9517 28.9485 26.1888 29.9796 26.614 30.9064C26.9177 31.568 27.3172 32.1765 27.7949 32.714"
          fill="white"
        />
        <path
          d="M31.7788 35.0299C32.2638 35.1194 32.7572 35.1659 33.259 35.1694C37.2948 35.1694 40.5664 31.8978 40.5664 27.8621C40.5664 23.8263 37.2948 20.5547 33.259 20.5547C32.2223 20.5547 31.236 20.7706 30.3427 21.1599C28.7902 21.8363 27.5184 23.0364 26.7502 24.537C26.2397 25.5344 25.9517 26.6646 25.9517 27.8621C25.9517 28.9485 26.1888 29.9796 26.614 30.9064C26.9177 31.568 27.3172 32.1765 27.7949 32.714"
          stroke="#00B0F5"
          strokeWidth="0.689375"
          strokeLinecap="round"
        />
        <path
          d="M28.6533 33.5356C29.2457 34.0171 29.9149 34.4076 30.6397 34.686"
          stroke="#00B0F5"
          strokeWidth="0.689375"
          strokeLinecap="round"
        />
        <path
          d="M40.8423 35.1694L42.4968 36.8239"
          stroke="#00B0F5"
          strokeWidth="0.689375"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.2293 36.5565C41.7074 37.0784 41.7074 37.9246 42.2293 38.4465L45.2861 41.5033C45.808 42.0252 46.6542 42.0252 47.1761 41.5033C47.698 40.9814 47.698 40.1352 47.1761 39.6132L44.1194 36.5565C43.5974 36.0346 42.7512 36.0346 42.2293 36.5565Z"
          fill="#E8F0FE"
          stroke="#00B0F5"
          strokeWidth="0.689375"
        />
        <path
          d="M43.5999 37.0996L46.6331 40.1329"
          stroke="white"
          strokeWidth="0.689375"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.4668 24.6909C31.4668 27.8891 34.0594 30.4817 37.2576 30.4817C37.8858 30.4817 38.4907 30.3816 39.0572 30.1966C38.1326 32.4911 35.885 34.1107 33.2592 34.1107C29.8081 34.1107 27.0105 31.3131 27.0105 27.8621C27.0105 24.7349 29.3076 22.1443 32.3065 21.6855C31.7737 22.5619 31.4668 23.5906 31.4668 24.6909Z"
          fill="#E8F0FE"
        />
        <path
          d="M33.397 22.7607C33.0458 22.7607 32.7028 22.7953 32.371 22.8612M31.3688 23.1678C29.4824 23.9605 28.1577 25.8255 28.1577 28"
          stroke="#E5F6FF"
          strokeWidth="0.689375"
          strokeLinecap="round"
        />
        <path
          d="M48.0602 27.9385H45.8057M49.8041 25.7939H45.0679H49.8041ZM51.7343 25.7939H51.1218H51.7343Z"
          stroke="#E5F6FF"
          strokeWidth="0.689375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.2426 34.0048H20.9881M21.9533 31.5845H17.217H21.9533ZM15.611 31.5845H14.447H15.611Z"
          stroke="#E5F6FF"
          strokeWidth="0.689375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default NoGlobalSearch;
